// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableRow-root .MuiTableCell-root .css-18kntrs {
  background-color: #ffeb3b !important;
}

.UserManagement {
  width: 100%;
  height: 100%;
  padding: 0.625rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
}
.UserManagement .AddUser {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.UserManagement .AddUser button {
  height: 1.75rem;
  width: 8rem;
  background: var(--AccentColor);
  color: #ffffff;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
}
.UserManagement .TableContainer {
  flex: 1 1;
  width: 100%;
  font-size: 0.875rem;
  overflow: auto;
}
.UserManagement .TableContainer .actions {
  height: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
}
.UserManagement .TableContainer .actions div svg {
  cursor: pointer;
}
.UserManagement .TableContainer .actions div svg path {
  fill: var(--AccentColor);
}
.UserManagement .TableContainer .actions div .enabled {
  cursor: pointer;
}
.UserManagement .TableContainer .actions div .disabled {
  cursor: default;
  opacity: 0.2;
  cursor: not-allowed;
}
.UserManagement .TableContainer ::-webkit-scrollbar {
  width: 0.3rem;
  height: 0.3rem;
  background-color: var(--Foreground);
}
.UserManagement .TableContainer ::-webkit-scrollbar-thumb {
  background-color: var(--AccentColor);
  border-radius: 10px;
}
.UserManagement .TableContainer ::-webkit-scrollbar-track {
  background-color: var(--Foreground);
  border-radius: 10px;
}
.UserManagement .TableContainer ::-webkit-scrollbar-corner {
  background-color: var(--Foreground);
}
.UserManagement .TableContainer .MuiPaper-root {
  height: 100%;
}
.UserManagement .AddUserModal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.UserManagement .AddUserModal .Modal {
  background: var(--Foreground);
  padding: 2.5rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  min-width: 25rem;
  max-height: 90%;
  overflow: auto;
}
.UserManagement .AddUserModal .Modal .LoadCont {
  min-height: 20rem;
  width: 100%;
  position: relative;
  border-radius: 1rem;
}
.UserManagement .AddUserModal .Modal header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.UserManagement .AddUserModal .Modal header h1 {
  flex: 1 1;
  color: var(--TextColor);
  font-size: 1.25rem;
  font-weight: 700;
}
.UserManagement .AddUserModal .Modal header button {
  width: 3.75rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  background: #eaebed;
  color: #212121;
  border: none;
  font-size: 0.75rem;
  cursor: pointer;
}
.UserManagement .AddUserModal .Modal header .Save {
  background: var(--AccentColor);
  color: #ffffff;
}
.UserManagement .AddUserModal .Modal .InputContainer {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.UserManagement .AddUserModal .Modal .InputContainer input {
  padding: 0 0.75rem;
  border: none;
  background: none;
  border-bottom: 0.0625rem solid var(--Stroke);
  height: 2rem;
  color: var(--TextColor);
  font-size: 0.875rem;
}
.UserManagement .AddUserModal .Modal .InputContainer input:not(:placeholder-shown) {
  background: rgba(215, 237, 255, 0.3019607843);
}
.UserManagement .AddUserModal .Modal h3 {
  width: 100%;
  font-size: 1.125rem;
  color: var(--TextColor);
  font-weight: 700;
  margin-top: 0.5rem;
}
.UserManagement .AddUserModal .Modal .ToggleSection {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
  overflow: auto;
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue {
  display: flex;
  width: calc(100% - 0.5rem);
  padding: 0 0.5rem 0.25rem 0.5rem;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  border-bottom: 0.0625rem solid var(--Stroke);
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue span {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue .Toggle {
  width: 2.25rem;
  height: 1.5rem;
  border-radius: 1rem;
  background: var(--Background);
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue .Toggle::after {
  content: "";
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #9b9b9b;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.25rem;
  transition: all 0.2s ease-in-out;
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue .Active {
  background: var(--Invitation);
  transition: all 0.2s ease-in-out;
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue .Active::after {
  content: "";
  left: 1rem;
  transition: all 0.2s ease-in-out;
  background: var(--AccentColor);
}
.UserManagement .AddUserModal .Modal .ToggleSection .ToggleValue .NotAllowed {
  cursor: not-allowed;
}
.UserManagement .AddUserModal .Modal .Opacity {
  opacity: 0.7;
}
.UserManagement .AddUserModal .Modal .Header {
  flex: 1 1;
  color: var(--TextColor);
  font-size: 1.5rem;
  font-weight: 700;
}
.UserManagement .AddUserModal .Modal .Caption {
  font-size: 0.875rem;
  color: var(--TextColor);
}
.UserManagement .AddUserModal .Modal .ButtonContainer {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.25rem;
}
.UserManagement .AddUserModal .Modal .ButtonContainer button {
  width: 5rem;
  height: 1.75rem;
  background: #eaebed;
  border: none;
  color: #212121;
  border-radius: 0.25rem;
  cursor: pointer;
}
.UserManagement .AddUserModal .Modal .ButtonContainer .Yes {
  background: var(--AccentColor);
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/Components/UserManagement/UserManagement.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAEJ;AADI;EACE,eAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAGN;AAAE;EACE,SAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAEJ;AADI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AAGN;AADQ;EACE,eAAA;AAGV;AAFU;EACE,wBAAA;AAIZ;AADQ;EACE,eAAA;AAGV;AADQ;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AAGV;AACI;EACE,aAAA;EACA,cAAA;EACA,mCAAA;AACN;AACI;EACE,oCAAA;EACA,mBAAA;AACN;AACI;EACE,mCAAA;EACA,mBAAA;AACN;AACI;EACE,mCAAA;AACN;AACI;EACE,YAAA;AACN;AAEE;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AACI;EACE,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACN;AAAM;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAER;AAAM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAER;AADQ;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAGV;AADQ;EACE,cAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAGV;AADQ;EACE,8BAAA;EACA,cAAA;AAGV;AAAM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAER;AADQ;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,4CAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAGV;AADQ;EACE,6CAAA;AAGV;AAAM;EACE,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAER;AAAM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;AAER;AADQ;EACE,aAAA;EACA,0BAAA;EACA,gCAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,4CAAA;AAGV;AAFU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIZ;AAFU;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAIZ;AAHY;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,gCAAA;AAKd;AAFU;EACE,6BAAA;EACA,gCAAA;AAIZ;AAHY;EACE,WAAA;EACA,UAAA;EACA,gCAAA;EACA,8BAAA;AAKd;AAFU;EACE,mBAAA;AAIZ;AAAM;EACE,YAAA;AAER;AAAM;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAER;AAAM;EACE,mBAAA;EACA,uBAAA;AAER;AAAM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAER;AADQ;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AAGV;AADQ;EACE,8BAAA;EACA,cAAA;AAGV","sourcesContent":[".MuiTableRow-root .MuiTableCell-root .css-18kntrs {\n  background-color: #ffeb3b !important;\n}\n\n.UserManagement {\n  width: 100%;\n  height: 100%;\n  padding: 0.625rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow: auto;\n  .AddUser {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    button {\n      height: 1.75rem;\n      width: 8rem;\n      background: var(--AccentColor);\n      color: #ffffff;\n      border-radius: 0.25rem;\n      border: none;\n      cursor: pointer;\n      font-size: 0.875rem;\n    }\n  }\n  .TableContainer {\n    flex: 1;\n    width: 100%;\n    font-size: 0.875rem;\n    overflow: auto;\n    .actions {\n      height: 2rem;\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      justify-content: center;\n      div{\n        svg {\n          cursor: pointer;\n          path {\n            fill: var(--AccentColor);\n          }\n        }\n        .enabled {\n          cursor: pointer;\n        }\n        .disabled {\n          cursor: default;\n          opacity: 0.2;\n          cursor: not-allowed;\n        }\n      }\n    }\n    ::-webkit-scrollbar {\n      width: 0.3rem;\n      height: 0.3rem;\n      background-color: var(--Foreground);\n    }\n    ::-webkit-scrollbar-thumb {\n      background-color: var(--AccentColor);\n      border-radius: 10px;\n    }\n    ::-webkit-scrollbar-track {\n      background-color: var(--Foreground);\n      border-radius: 10px;\n    }\n    ::-webkit-scrollbar-corner {\n      background-color: var(--Foreground);\n    }\n    .MuiPaper-root {\n      height: 100%;\n    }\n  }\n  .AddUserModal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    background: #000000b3;\n    backdrop-filter: blur(3px);\n    z-index: 9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .Modal {\n      background: var(--Foreground);\n      padding: 2.5rem;\n      border-radius: 0.5rem;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 1rem;\n      min-width: 25rem;\n      max-height: 90%;\n      overflow: auto;\n      .LoadCont{\n        min-height: 20rem;\n        width: 100%;\n        position: relative;\n        border-radius: 1rem;\n      }\n      header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        h1 {\n          flex: 1;\n          color: var(--TextColor);\n          font-size: 1.25rem;\n          font-weight: 700;\n        }\n        button {\n          width: 3.75rem;\n          height: 1.5rem;\n          border-radius: 0.25rem;\n          background: #eaebed;\n          color: #212121;\n          border: none;\n          font-size: 0.75rem;\n          cursor: pointer;\n        }\n        .Save {\n          background: var(--AccentColor);\n          color: #ffffff;\n        }\n      }\n      .InputContainer {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        width: 100%;\n        input {\n          padding: 0 0.75rem;\n          border: none;\n          background: none;\n          border-bottom: 0.0625rem solid var(--Stroke);\n          height: 2rem;\n          color: var(--TextColor);\n          font-size: 0.875rem;\n        }\n        input:not(:placeholder-shown) {\n          background: #d7edff4d;\n        }\n      }\n      h3 {\n        width: 100%;\n        font-size: 1.125rem;\n        color: var(--TextColor);\n        font-weight: 700;\n        margin-top: 0.5rem;\n      }\n      .ToggleSection {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n        width: 100%;\n        overflow: auto;\n        .ToggleValue {\n          display: flex;\n          width: calc(100% - 0.5rem);\n          padding: 0 0.5rem 0.25rem 0.5rem;\n          align-items: center;\n          gap: 1rem;\n          justify-content: space-between;\n          border-bottom: 0.0625rem solid var(--Stroke);\n          span {\n            font-size: 0.875rem;\n            font-weight: 500;\n            color: var(--TextColor);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n          .Toggle {\n            width: 2.25rem;\n            height: 1.5rem;\n            border-radius: 1rem;\n            background: var(--Background);\n            position: relative;\n            cursor: pointer;\n            transition: all 0.2s ease-in-out;\n            &::after {\n              content: \"\";\n              width: 1rem;\n              height: 1rem;\n              border-radius: 50%;\n              background: #9b9b9b;\n              position: absolute;\n              top: 50%;\n              transform: translateY(-50%);\n              left: 0.25rem;\n              transition: all 0.2s ease-in-out;\n            }\n          }\n          .Active {\n            background: var(--Invitation);\n            transition: all 0.2s ease-in-out;\n            &::after {\n              content: \"\";\n              left: 1rem;\n              transition: all 0.2s ease-in-out;\n              background: var(--AccentColor);\n            }\n          }\n          .NotAllowed {\n            cursor: not-allowed;\n          }\n        }\n      }\n      .Opacity {\n        opacity: 0.7;\n      }\n      .Header {\n        flex: 1;\n        color: var(--TextColor);\n        font-size: 1.5rem;\n        font-weight: 700;\n      }\n      .Caption {\n        font-size: 0.875rem;\n        color: var(--TextColor);\n      }\n      .ButtonContainer {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        justify-content: center;\n        margin-top: 1.25rem;\n        button {\n          width: 5rem;\n          height: 1.75rem;\n          background: #eaebed;\n          border: none;\n          color: #212121;\n          border-radius: 0.25rem;\n          cursor: pointer;\n        }\n        .Yes {\n          background: var(--AccentColor);\n          color: #ffffff;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
